import { FileObject } from '@citruscamps/citrus-client'
import { Placement } from '@floating-ui/react'
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Popover } from '../../Popover/Popover'
import { usePopper } from '../../Popover/hooks/usePopper'

interface IProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'value'> {
  value?: FileObject
  showOn?: 'click' | 'hover'
  placement: Placement
  onOpenModal?: (tab?: 'library' | 'stock' | 'upload') => void | Promise<void>
  onEdit?: () => void | Promise<void>
  onRemove?: () => void | Promise<void>
}

export const MediaActionButton = ({
  value,
  placement,
  children = <FontAwesomeIcon icon={faEllipsisV} />,
  onOpenModal: handleOpenModal,
  onEdit: handleEdit,
  onRemove: handleRemove,
  ...props
}: React.PropsWithChildren<IProps>) => {
  const { target, toggle, targetProps, ...tooltipProps } = usePopper<HTMLButtonElement>({
    placement,
  })
  return (
    <div>
      <button
        ref={target}
        type="button"
        className="btn"
        onClick={(): void => toggle()}
        {...props}
        {...targetProps}
      >
        {children}
      </button>
      <Popover {...tooltipProps} toggle={toggle}>
        {!value && (
          <>
            <button
              type="button"
              onClick={() => {
                handleOpenModal?.('library')
                toggle()
              }}
              className="dropdown-item"
            >
              Select from library
            </button>
            <button
              type="button"
              onClick={() => {
                handleOpenModal?.('stock')
                toggle()
              }}
              className="dropdown-item border-top"
            >
              Browse stock images
            </button>
            <button
              type="button"
              onClick={() => {
                handleOpenModal?.('upload')
                toggle()
              }}
              className="dropdown-item border-top"
            >
              Upload file
            </button>
          </>
        )}
        {!!value && (
          <>
            <button
              type="button"
              onClick={() => {
                handleOpenModal?.('library')
                toggle()
              }}
              className="dropdown-item"
            >
              Replace
            </button>
            <button
              type="button"
              onClick={() => {
                handleEdit?.()
                toggle()
              }}
              className="dropdown-item border-top"
            >
              Edit
            </button>
            <button
              type="button"
              onClick={() => {
                handleRemove?.()
                toggle()
              }}
              className="dropdown-item text-danger border-top"
            >
              Remove
            </button>
          </>
        )}
      </Popover>
    </div>
  )
}
